import type { SvgIconProps } from "@mui/material"
import { CustomIcon } from "../../../common/Icon/CustonIcon"

export const AIViewIcon = (props: SvgIconProps) => {
    const svgContent = (
        <>
            {/* Cuadro con esquina de globo de diálogo */}
            <path
                d="M19 3H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h3l3 3 3-3h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H13.2l-1.8 1.8L9.5 15H5V5h14v10z"
                fill="currentColor"
            />
            {/* Texto "AI" */}
            <text
                x="12"
                y="12"
                dominantBaseline="middle"
                textAnchor="middle"
                fontSize="8"
                fill="currentColor"
                style={{
                    fontFamily: "Arial, sans-serif",
                    fontWeight: "bold",
                }}
            >
                AI
            </text>
        </>
    )

    return <CustomIcon svgContent={svgContent} {...props} />
}

